import { db } from './localDb.js'
import { getSession } from '../auth/auth.js'

// ==================== CRUD NOTAS FISCAIS ====================

export async function createNotaFiscal(payload) {
  const session = getSession()
  const empresaId = session?.empresaId
  const now = Date.now()

  const nf = {
    id: crypto.randomUUID(),
    numero: (payload.numero ?? '').trim(),
    serie: (payload.serie ?? '').trim() || null,
    dataEmissao: payload.dataEmissao ? String(payload.dataEmissao).trim() : null,
    cnpjFornecedor: (payload.cnpjFornecedor ?? '').trim() || null,
    fornecedorNome: (payload.fornecedorNome ?? '').trim() || null,
    valorTotal: payload.valorTotal !== undefined && payload.valorTotal !== ''
      ? Number(payload.valorTotal)
      : null,
    arquivoBase64: payload.arquivoBase64 || null,
    observacao: (payload.observacao ?? '').trim() || null,
    status: 'ativa',
    empresaId: empresaId || null,
    criadoEm: now,
    atualizadoEm: now,
    pendingSync: 1
  }

  await db.notasFiscais.add(nf)
  return nf.id
}

export async function updateNotaFiscal(id, patch) {
  const updates = {}
  if (patch.numero !== undefined) updates.numero = (patch.numero ?? '').trim()
  if (patch.serie !== undefined) updates.serie = (patch.serie ?? '').trim() || null
  if (patch.dataEmissao !== undefined) updates.dataEmissao = patch.dataEmissao ? String(patch.dataEmissao).trim() : null
  if (patch.cnpjFornecedor !== undefined) updates.cnpjFornecedor = (patch.cnpjFornecedor ?? '').trim() || null
  if (patch.fornecedorNome !== undefined) updates.fornecedorNome = (patch.fornecedorNome ?? '').trim() || null
  if (patch.valorTotal !== undefined) {
    updates.valorTotal = (patch.valorTotal === '' || patch.valorTotal === null)
      ? null
      : Number(patch.valorTotal)
  }
  if (patch.arquivoBase64 !== undefined) updates.arquivoBase64 = patch.arquivoBase64 || null
  if (patch.observacao !== undefined) updates.observacao = (patch.observacao ?? '').trim() || null
  if (patch.status !== undefined) updates.status = patch.status

  updates.atualizadoEm = Date.now()
  updates.pendingSync = 1

  await db.notasFiscais.update(id, updates)
}

export async function deleteNotaFiscal(id) {
  // Soft delete - marcar como cancelada
  await db.notasFiscais.update(id, {
    status: 'cancelada',
    atualizadoEm: Date.now(),
    pendingSync: 1
  })
}

export async function getNotaFiscalById(id) {
  return db.notasFiscais.get(id)
}

export async function listNotasFiscais({ q = '', status = 'todos' } = {}) {
  const session = getSession()
  const empresaId = session?.empresaId
  let all = await db.notasFiscais.toArray()

  if (empresaId) {
    all = all.filter(nf => nf.empresaId === empresaId)
  }

  if (status !== 'todos') {
    all = all.filter(nf => nf.status === status)
  }

  if (q.trim()) {
    const query = q.toLowerCase()
    all = all.filter(nf =>
      (nf.numero ?? '').toLowerCase().includes(query) ||
      (nf.fornecedorNome ?? '').toLowerCase().includes(query) ||
      (nf.cnpjFornecedor ?? '').toLowerCase().includes(query)
    )
  }

  return all.sort((a, b) => (b.criadoEm ?? 0) - (a.criadoEm ?? 0))
}

export async function getNotasFiscaisAtivas() {
  return listNotasFiscais({ status: 'ativa' })
}

// Vincular/desvincular NF em produto
export async function vincularNotaFiscalProduto(produtoId, notaFiscalId) {
  await db.produtos.update(produtoId, {
    notaFiscalId: notaFiscalId || null,
    atualizadoEm: Date.now(),
    pendingSync: 1
  })
}
